export default __webpack_public_path__ + "static/Product-378e8e8de21d8983498c418f89129d00.mp4";